var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C9.22565 1.53357 6.5744 2.65059 4.61249 4.61249C2.65059 6.5744 1.53357 9.22565 1.5 12C1.53357 14.7743 2.65059 17.4256 4.61249 19.3875C6.5744 21.3494 9.22565 22.4664 12 22.5C14.7743 22.4664 17.4256 21.3494 19.3875 19.3875C21.3494 17.4256 22.4664 14.7743 22.5 12C22.4664 9.22565 21.3494 6.5744 19.3875 4.61249C17.4256 2.65059 14.7743 1.53357 12 1.5ZM18 12.75H12.75V18H11.25V12.75H6V11.25H11.25V6H12.75V11.25H18V12.75Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusCircleFill);
export default __webpack_public_path__ + "static/media/ic-plus-circle-fill.b1acdb468a4316b18f5c06fd616f7cdf.svg";
export { ForwardRef as ReactComponent };